var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.section.limitation_visible())?_c('div',{staticClass:"row meeting-time"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.age_limit(_vm.section))}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.grade_limit(_vm.section))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }